import React, { useEffect, useState } from "react";
import { AiTwotoneStar } from "react-icons/ai";
const ReviewCard: React.FC<reviewProps> = ({ data, reviewType, reviewRef }) => {
  const [readMoreActive, setReadMoreActive] = useState(false);
  const [reviewMsg, setReviewMsg] = useState("");

  const handleTruncate = (text: string) => {
    if (text.length > 380) {
      setReadMoreActive(true);
      const truncateMsg: string = text.substring(0, 380);
      setReviewMsg(truncateMsg);
    } else {
      setReadMoreActive(false);
      setReviewMsg(text);
    }
  };
  console.log(data.img);

  useEffect(() => {
    handleTruncate(data.review);
  }, [data.review]);

  return (
    <div
      className="shadow-lg rounded-md p-4  lg:p-6 border border-gray-200 my-5 lg:my-10 bg-white"
      ref={reviewRef}
    >
      <p className="text-primary-base mb-1 font-semibold text-sm capitalize">
        {reviewType}
      </p>

      <div className="flex items-center justify-between">
        <h1 className="font-semibold text-xl">{data.reviewHighlight}</h1>
        <div className="flex items-center space-x-1 text-xl">
          {[...Array(data.stars)].map((x, i) => (
            <AiTwotoneStar className="text-yellow-400" key={i} />
          ))}
        </div>
      </div>

      <p className="mt-4 text-justify">
        {reviewMsg}{" "}
        {readMoreActive && (
          <span
            className="text-blue-500 cursor-pointer ml-2"
            onClick={() => {
              setReviewMsg(data.review);
              setReadMoreActive(false);
            }}
          >
            Read More....
          </span>
        )}
      </p>

      <div className="flex items-center mt-8 space-x-4">
        {data.img !== "no_img" ? (
          <img
            src={`${process.env.REACT_APP_API}/uploads/images/${data.img}`}
            className="h-16 w-16 rounded-full object-cover"
          />
        ) : (
          <div className="h-16 w-16 rounded-full bg-gray-300 flex items-center justify-center font-bold capitalize">
            {data.name.split("")[0]}
          </div>
        )}
        <div>
          <h1 className="font-semibold text-lg">{data.name} </h1>
          <p>{data.location} </p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
